<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TopoEditor',
})
</script>
<template>
<div class="topo-editor">
    <WresizePanel2 class="full-height">
        <template v-slot:left>
            <TopoToolbox ref="topoToolbox" class="topo-toolbox" />
        </template>
        <template v-slot:right>
            <TopoMain ref="topoMain" style="width: 100%;height:100%;" />
        </template>
    </WresizePanel2>
</div>
</template>

<script setup lang="ts" name="TopoEditor">
import WresizePanel2 from '@/components/Topo/panel/WresizePanel2.vue';
import TopoToolbox from '@/components/Topo/topo/TopoToolbox.vue';
import TopoMain from '@/components/Topo/topo/TopoMain.vue';

import { topoData } from '@/store/topo-editor/getters';
import {onMounted, ref} from 'vue'
</script>

<style lang="scss">
.topo-editor {
    padding: 10px;
    position: relative;
    width: 100%;
    height: 100vh;
    background-color: #eee;
    .full-height{height:100%;}
    .topo-toolbox {
        width: 100%;
        height: 100%;
    }

    .topo-main {
        width: 70%;
        height: 100%;
    }

    .topo-properties {
        width: 30%;
        height: 100%;
    }
}
</style>
